import * as yup from 'yup';

export const createLiveMentionManualSchema = yup.object().shape({
  datetime: yup.string().required(),
  mentionSchedules: yup
    .object({
      name: yup.string(),
      description: yup.string(),
    })
    .nullable(true),
  mentionCustom: yup.object({
    name: yup.string(),
    description: yup.string(),
  }),
});
